import Vue from 'vue'
import Router, { NavigationGuardNext } from 'vue-router'
import Home from './views/Home.vue'
import MapView from './views/MapView.vue'
import MapEditor from './views/MapEditor.vue'
import SignIn from './views/SignIn.vue'
import Admin from './views/Admin.vue'
import DeleteMap from './views/DeleteMap.vue'
import MailSent from './views/MailSent.vue'
import store from './vuex/store'
import firebase from "firebase/app";


Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				awaitAuth: true,
			},
		},
		{
			path: '/create',
			name: 'create',
			component: MapEditor,
			meta: {
				needsSignIn: true,
				isNew: true,
			},
		},
		{
			path: '/admin',
			name: 'admin',
			component: Admin,
			meta: {
				needsSignIn: true
			},
		},
		{
			path: '/signin',
			name: 'signin',
			component: SignIn,
			meta: {
				awaitAuth: true,
			},
		},
		{
			path: '/mailsent',
			name: 'mailsent',
			component: MailSent,
			meta: {
				awaitAuth: true,
			},
		},
		{
			path: '/:id',
			name: 'map',
			component: MapView,
		},
		{
			path: '/:id/edit',
			name: 'edit',
			component: MapEditor,
			meta: {
				needsSignIn: true,
				isNew: false,
			},
		},
		{
			path: '/:id/about',
			name: 'about',
			component: MapView,
		},
		{
			path: '/:id/delete',
			name: 'delete',
			component: DeleteMap,
			meta: {
				needsSignIn: true,
			},
		},
	]
})

function triggerNext(next:NavigationGuardNext<Vue>, then:string, needsSignIn) {
	if(store.getters.signedIn || !needsSignIn)
		next();
	else
		next({path:"/signin", query:{then:then}});
}

router.afterEach((to, from) => {
	firebase.analytics().setCurrentScreen(to.path);
	firebase.analytics().logEvent('screen_view');
	console.log("Page:", to.path)
})

router.beforeEach((to, from, next) => {

	// needsSignIn: can't go here without being signed in
	// awaitAuth: waith until we have the local auth state from firebase before entering this
	// route. (so we don't get a signed out flicker before getting signed in) 

	if(to.meta.needsSignIn || to.meta.awaitAuth) {
		if(store.state.authInitialized) {
			triggerNext(next, to.fullPath, to.meta.needsSignIn);
		} else {
			console.log("await auth change")
			const unwatch = store.watch(function (state) {
				return state.authInitialized;
			}, () => {
				triggerNext(next, to.fullPath, to.meta.needsSignIn);
				unwatch();
			})
		}
	} else {
		next();
	}
})

export default router